/**
 * Cache de configuração com prazo de validade.
 *
 * POR QUE EXISTE
 * Os três caches de configuração do desk — produtos, pesos de pontuação e regras de comissão —
 * eram de escopo de módulo e viviam o tempo inteiro da sessão do bundle. Não tinham prazo, e
 * `invalidateCommissionRulesCache` não tinha NENHUM chamador de aplicação: só teste. Os outros
 * dois só invalidavam na aba de quem tinha acabado de salvar pela tela.
 *
 * Consequência medida: uma mudança de configuração nunca alcançava uma aba já aberta. Quando as
 * 11 faixas de cash collect foram publicadas em 2026-09-01, qualquer aba do desk que já tivesse
 * completado uma venda naquela sessão continuava com `{rules: []}` grudado — e registrava venda
 * de Performance de R$ 54.000 com R$ 27.000 de entrada sem a linha de bônus de R$ 450. Sem erro,
 * sem log: a tela dizia "venda registrada". Duas vendas idênticas no mesmo minuto, por operadores
 * diferentes, produziam números diferentes conforme a idade da aba.
 *
 * O prazo resolve a classe inteira, não só aquele episódio: toda edição futura de configuração
 * passa a alcançar as abas abertas sozinha. Sessenta segundos é o mesmo intervalo do sweep, e
 * comprar uma leitura por minuto é barato perto de uma comissão errada que ninguém vê.
 *
 * O relógio é injetável porque teste que depende de espera real é teste que ninguém roda.
 */
export const TTL_CONFIG_MS = 60_000;

export function criarCacheComTtl(carregar, { ttlMs = TTL_CONFIG_MS, relogio = () => Date.now() } = {}) {
    let valor = null;
    let lidoEm = 0;
    let carregando = null;

    return {
        async ler() {
            const agora = relogio();
            if (valor !== null && agora - lidoEm < ttlMs) return valor;
            // Chamadas concorrentes compartilham a mesma leitura: sem isto, três consumidores
            // acordando juntos depois do prazo disparam três queries idênticas.
            if (!carregando) {
                carregando = (async () => {
                    try {
                        valor = await carregar();
                        lidoEm = relogio();
                        return valor;
                    } finally {
                        carregando = null;
                    }
                })();
            }
            return carregando;
        },
        invalidar() { valor = null; lidoEm = 0; },
        /** Só para teste: permite afirmar sobre o estado sem exportar as variáveis. */
        _estado() { return { temValor: valor !== null, lidoEm }; },
    };
}
